import type { GroupResponsibleState } from '@/scopes/account/group-responsible/domain/types'

export function isRoomAssignmentProcessing(state: GroupResponsibleState): boolean {
  return state.bookingData.group.isBlocked && state.roomAssignmentStatus !== 'error'
}
